export const catchServerError = (response: any) => {
  if (response.code === "cancel") {
    return null;
  }
  if (response?.message) {
    if (response.message === "Network Error") {
      return "Error de conexión";
    }
    if (response.message === "Request failed with status code 401") {
      return "No autorizado";
    }
    if (response.message === "Server Error") {
      return "Ups ha ocurrido un inconveniente";
    }
    return response.message;
  }

  if (response?.data?.data?.error) {
    return response?.data?.data?.error;
  }

  if (response?.data) {
    if (response.data.message === "Page not found") {
      return "Url no Valida o paramentos no validos";
    }
  }

  if (response?.data?.errors) {
    const { errors } = response.data;
    let message = "";
    for (const property in errors) {
      message += `${errors[property]}\n`;
    }
    return message;
  }

  if (response?.data?.message) {
    return response?.data.message;
  }

  return "Ups ha ocurrido un inconveniente";
};
